import { render, staticRenderFns } from "./model-selector-field.vue?vue&type=template&id=2b92b7ee&scoped=true"
import script from "./model-selector-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./model-selector-field.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92b7ee",
  null
  
)

export default component.exports